import { render } from "./OrderCommonFormComponent.vue?vue&type=template&id=1768f5a2&ts=true"
import script from "./OrderCommonFormComponent.vue?vue&type=script&lang=ts"
export * from "./OrderCommonFormComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__